import * as React from 'react';
import { InteractionReportBlock } from '../../../components';
import { } from '../../../models';
import { BaseRouteProps } from '../../../interfaces';
import { FilterStore } from '../../../stores';
import { observer, inject } from 'mobx-react';
import './InteractionReport.css';

interface InteractionReportProps extends BaseRouteProps<{}> {
    FilterStore?: FilterStore;
}

@inject('FilterStore') @observer
export class InteractionReport extends React.Component<InteractionReportProps, {}> {
    constructor(props: InteractionReportProps) {
        super(props);
    }

    public render() {
        return <InteractionReportBlock history={this.props.history} match={this.props.match} location={this.props.location} notificationService={this.props.notificationService} FilterStore={this.props.FilterStore} showDropDown={true} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/interaction/InteractionReport.tsx